 export default () => (input, searchText) => (input || []).filter(item => item.name && item.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/projecs-scope/projects-scope-search.filter.js